import React, { Component } from 'react';
import { supervisionPath } from '@/utils/utils';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

export default class IntroduceBase extends Component {

  render () {
    const IframeDom = Iframe({
      src: `${supervisionPath}/staff-work/team-introducement.html`,
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '9px 17px'}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}
